import {
    getCustomerSubscription,
    listCustomerSubscriptions
} from './queries';
import {
    activateCustomerSubscription,
    cancelCustomerSubscription,
    createCustomerSubscription,
    deleteCustomerSubscription,
    updateCustomerSubscription,
} from './mutations';

import {GraphQLQuery,} from '@aws-amplify/api';
import {CustomerSubscription} from "../types.ts";
import {
    notifyError,
    notifySuccess
} from "../../../components/PlatformNotification";
import { billingApiClient } from "../../billing-api-integration";
import {ListRecordsQuery} from "../../../types";


export type ListCustomerSubscriptions = {
    listCustomerSubscriptions: { items: CustomerSubscription[], nextToken: string }
}

export type GetCustomerSubscription = {
    getCustomerSubscription: CustomerSubscription
}

export type CreateCustomerSubscription = {
    createCustomerSubscription: CustomerSubscription
}

export type UpdateCustomerSubscription = {
    updateCustomerSubscription: CustomerSubscription
}

export type ActivateCustomerSubscription = {
    activateCustomerSubscription: CustomerSubscription
}

export type CancelCustomerSubscription = {
    cancelCustomerSubscription: CustomerSubscription
}

export type DeleteCustomerSubscription = {
    deleteCustomerSubscription: string
}


const client = billingApiClient;


export const fetchRecords = async (query: ListRecordsQuery) => {
    try {
        const response = await client.graphql<GraphQLQuery<ListCustomerSubscriptions>>({
                                                                                   query: listCustomerSubscriptions,
                                                                                   variables: {
                                                                                       ...query
                                                                                   },
                                                                               });
        return {
            items: response.data?.listCustomerSubscriptions.items,
            nextToken: response.data?.listCustomerSubscriptions.nextToken,
        };
    } catch (e) {
        console.trace(e);
        notifyError(e)
    }
};

export const fetch = async (id: string) => {
    try {
        const response = await client.graphql<GraphQLQuery<GetCustomerSubscription>>({
                                                                                 query: getCustomerSubscription,
                                                                                 variables: {id: id},
                                                                             });
        return response.data?.getCustomerSubscription;
    } catch (e) {
        console.trace(e);
        notifyError(e)
    }
};

export const add = async (payload: object) => {

    try {
        const response = await client.graphql<GraphQLQuery<CreateCustomerSubscription>>({
                                                                                    query: createCustomerSubscription,
                                                                                    variables: {input: payload},
                                                                                });
        console.debug('in the service response', response);
        notifySuccess('Customer Subscription added');
        return response.data?.createCustomerSubscription;
    } catch (e) {
        console.trace(e);
        notifyError(e)
    }
};

export const update = async (id: string, record: CustomerSubscription) => {

    console.debug('IN UPDATE', id, record);

    const { created, createdByUsername, createdByUser, updated, updatedByUsername, ...cleanData } = record;

    try {
        const response = await client.graphql<GraphQLQuery<UpdateCustomerSubscription>>({
                                                                                    query: (updateCustomerSubscription),
                                                                                    variables: {input: cleanData},
                                                                                });
        notifySuccess('Customer Subscription updated');
        return response.data?.updateCustomerSubscription;
    } catch (e) {
        console.trace(e);
        notifyError(e)
    }
};

export const activateRecord = async (id: string) => {
    try {
        const response = await client.graphql<GraphQLQuery<ActivateCustomerSubscription>>({
            query: activateCustomerSubscription,
            variables: { id }
        });
        notifySuccess('Customer Subscription activated');
        return response.data?.activateCustomerSubscription;
    } catch (e) {
        console.trace(e);
        notifyError(e);
    }
};

export const cancelRecord = async (id: string) => {
    try {
        const response = await client.graphql<GraphQLQuery<CancelCustomerSubscription>>({
            query: cancelCustomerSubscription,
            variables: { id }
        });
        notifySuccess('Customer Subscription cancelled');
        return response.data?.cancelCustomerSubscription;
    } catch (e) {
        console.trace(e);
        notifyError(e);
    }
};

export const deleteRecord = async (id: string) => {
    try {
        const response = await client.graphql<GraphQLQuery<DeleteCustomerSubscription>>({
                                                                                    query: (deleteCustomerSubscription),
                                                                                    variables: {input: {id: id}},

                                                                                });
        notifySuccess('Customer Subscription deleted');
        return response.data?.deleteCustomerSubscription;
    } catch (e) {
        console.trace(e);
        notifyError(e)
    }
};
